/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function RemoteControlActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g fill={color}>
        <path d="m12 15.6001c.9941 0 1.8.8059 1.8 1.8-.0001.9941-.8059 1.8-1.8 1.8s-1.7999-.8059-1.8-1.8c0-.9941.8059-1.8 1.8-1.8z" />
        <path clip-rule="evenodd" d="m17.325 1.49776c.3592-.03761.675.24357.675.60469v19.79535c-.0001.361-.3159.6417-.675.6041-1.0532-.1104-3.1891-.3018-5.325-.3018-2.13588 0-4.27177.1914-5.325.3018-.35913.0376-.67493-.2431-.675-.6041v-19.79535c0-.36112.31585-.6423.675-.60469 1.05323.11038 3.18912.30235 5.325.30235 2.1359 0 4.2718-.19197 5.325-.30235zm-5.325 12.75234c-1.7397 0-3.15 1.4103-3.15 3.15.00007 1.7396 1.4103 3.15 3.15 3.15s3.1499-1.4104 3.15-3.15c0-1.7397-1.4103-3.15-3.15-3.15zm-2.1-2.85c-.49706 0-.9.403-.9.9.00007.497.40299.9.9.9.497 0 .8999-.403.9-.9 0-.497-.4029-.9-.9-.9zm4.2 0c-.4971 0-.9.403-.9.9.0001.497.403.9.9.9s.8999-.403.9-.9c0-.497-.4029-.9-.9-.9zm-4.2-2.99999c-.49706 0-.9.40294-.9.9.00007.497.40299.89999.9.89999.497 0 .8999-.40299.9-.89999 0-.49706-.4029-.9-.9-.9zm4.2 0c-.4971 0-.9.40294-.9.9.0001.497.403.89999.9.89999s.8999-.40299.9-.89999c0-.49706-.4029-.9-.9-.9zm-4.2-3c-.49706 0-.9.40294-.9.9.00007.497.40299.9.9.9.497 0 .8999-.403.9-.9 0-.49706-.4029-.9-.9-.9zm4.2 0c-.4971 0-.9.40294-.9.9.0001.497.403.9.9.9s.8999-.403.9-.9c0-.49706-.4029-.9-.9-.9z" fill-rule="evenodd" />
      </g>
    </SVGWrapper>
  );
}

export default RemoteControlActiveIcon;
